<div class="rd-widget table-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetNoiProjection" class="widget-small widgetNoiProjectionClass cellspacing-0 cellpadding-0" style="height: 100%;" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" colspan="16" class="widget-grid-column widget-header-red" style="text-align: start;">
          <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Noi Projection</widget-value>
        </th>
      </tr>
    </thead>

    <tbody>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="dark-grey-line golden-line-widget-table">
          <td colspan="10">
            {{'nOIProjection.usNOIProjectionIncomeType' | rdTranslate}}
          </td>
          <td colspan="4">
            {{'nOIProjection.labelIncomeAnnual' | rdTranslate}}
          </td>
          <td colspan="2">
            {{widgetData.usNOIProjectionUnitOfMeasure}}
          </td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let entry of widgetData.incomeRows; let i = index">
        <dynamic-growth-row [row]="i + 2" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="10">
              <widget-value [align]="'left'">{{entry.usNOIProjectionIncomeType}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usNOIProjectionIncomeAnnual | rdLocalizedNumber:2}} {{currency}} </widget-value>
            </td>
            <td colspan="2">
              <widget-value [align]="'left'">{{entry.usNOIProjectionIncomeAnnualPerAreaOrPerUnit | rdLocalizedNumber:2}} {{currency}} </widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData?.incomeRows?.length + 2" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="10" class="widget-bold">
            {{'nOIProjection.labelEffectiveGrossIncome' | rdTranslate}}
          </td>
          <td colspan="4" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionEffectiveGrossIncomeAnnual | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
          <td colspan="2" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionEffectiveGrossIncomeAnnualPerAreaOrPerUnit | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.incomeRows?.length + 3" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="16">
            {{'nOIProjection.usNOIProjectionExpenseType' | rdTranslate}}
          </td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let entry of widgetData.expenseRows; let i = index">
        <dynamic-growth-row [row]="widgetData?.incomeRows?.length + i + 4" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="10">
              <widget-value [align]="'left'">{{entry.usNOIProjectionExpenseType}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usNOIProjectionExpenseAnnual | rdLocalizedNumber:2}} {{currency}} </widget-value>
            </td>
            <td colspan="2">
              <widget-value [align]="'left'">{{entry.usNOIProjectionExpenseAnnualPerAreaOrPerUnit | rdLocalizedNumber:2}} {{currency}} </widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData?.incomeRows?.length + widgetData?.expenseRows?.length + 4" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="10" class="widget-bold">
            {{'nOIProjection.labelTotalExpenses' | rdTranslate}}
          </td>
          <td colspan="4" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionTotalExpensesAnnual | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
          <td colspan="2" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionTotalExpensesAnnualPerAreaOrPerUnit | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.incomeRows?.length + widgetData?.expenseRows?.length + 5" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="10" class="widget-bold">
            {{'nOIProjection.labelNetOperatingIncome' | rdTranslate}}
          </td>
          <td colspan="4" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionNOIAnnual | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
          <td colspan="2" class="widget-bold">
            <widget-value [align]="'left'">{{widgetData.usNOIProjectionNOIAnnualPerAreaOrPerUnit | rdLocalizedNumber:2}} {{currency}} </widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
